import { BaseComponent } from './base.component';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';


export class CardTabComponent extends BaseComponent {
    public editing = false;
    public form: FormGroup;
    public parent: ICardTabActions;
    public activateChild(parent: ICardTabActions) {
        parent.allowEdit = false;
        this.parent = parent;
    }

    public get ngForm() {
        return null;
    }

    public get actions() {
        return null;
    }

    public edit() {
    }

    public patchValue(value: any) {

    }

    public cancelEdit() {
    }

    public submit() {

    }
}

export interface ICardTabActions {
    editing: boolean;
    allowEdit: boolean;
}

export interface IApplicationActions extends ICardTabActions {
    load(): void;
    confirmIfNeeded();
    parent: IApplicationActions;
}

